"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedwindy = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 59 34",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedwindy` : '') + (description ? ` desc-brandedwindy` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedwindy"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedwindy"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M58.74 17a8.9 8.9 0 0 0-7.15-8.79A13.12 13.12 0 0 0 39.5 0c-4.73 0-8.87 2.57-11.18 6.42a9.82 9.82 0 0 0-5.88-1.95 10.1 10.1 0 0 0-9.66 7.44C7.69 10.6 2.74 14.1 2.74 18.8c0 4.7 4.84 8.15 9.93 6.9a7.83 7.83 0 0 0 6.7 3.83 7.8 7.8 0 0 0 6.1-2.96A13.95 13.95 0 0 0 37.73 34c5.3 0 10.31-3.3 12.58-8.07a8.85 8.85 0 0 0 8.42-8.94V17Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M51.57 8.2a13.37 13.37 0 0 0-4.9-6 106.64 106.64 0 0 1-31.43 26 7.66 7.66 0 0 0 10.28-1.7 13.9 13.9 0 0 0 12.24 7.42c5.28 0 10.29-3.3 12.55-8.05a8.83 8.83 0 0 0 8.4-8.9v-.02a8.87 8.87 0 0 0-7.14-8.76Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M30.55 21.49H.9a.9.9 0 0 1-.9-.9c0-.5.4-.91.9-.91h29.64A2.67 2.67 0 0 0 33.22 17a2.67 2.67 0 0 0-2.65-2.7c-1.14 0-2.14.72-2.52 1.79a.9.9 0 0 1-1.14.55.9.9 0 0 1-.55-1.15 4.5 4.5 0 0 1 4.22-3A4.48 4.48 0 0 1 35 17a4.48 4.48 0 0 1-4.45 4.48Z",
    fill: "#8AE6EB"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.58 33.12a4.43 4.43 0 0 1-4.17-3 .9.9 0 0 1 .54-1.15.88.88 0 0 1 1.13.55 2.64 2.64 0 0 0 2.5 1.79h.01a2.67 2.67 0 0 0 2.64-2.7 2.67 2.67 0 0 0-2.65-2.68H.89a.9.9 0 0 1-.89-.9c0-.5.4-.91.9-.91h17.69A4.46 4.46 0 0 1 23 28.59a4.6 4.6 0 0 1-1.28 3.2 4.31 4.31 0 0 1-3.12 1.32h-.02v.01Z",
    fill: "#8AE6EB"
  }));
};
var _default = exports.default = brandedwindy;